import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  const navBg = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50';

  const textColor = isHome && !scrolled
    ? 'text-white'
    : 'text-foreground-900';

  const logoColor = isHome && !scrolled
    ? 'text-white'
    : 'text-primary-600';

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${navBg} ${scrolled || !isHome ? 'border-b border-background-200/60' : ''}`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link to="/" className={`text-xl md:text-2xl font-bold font-heading whitespace-nowrap ${logoColor} transition-colors duration-300`}>
            韩漫吧
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 ${textColor} ${isHome && !scrolled ? 'hover:text-white/80' : 'hover:text-primary-600'}`}>
              首页
            </Link>

            <div
              className="relative"
              onMouseEnter={() => setCategoryOpen(true)}
              onMouseLeave={() => setCategoryOpen(false)}
            >
              <button
                className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap transition-colors duration-300 ${textColor} ${isHome && !scrolled ? 'hover:text-white/80' : 'hover:text-primary-600'}`}
              >
                分类浏览
                <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${categoryOpen ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </span>
              </button>

              {categoryOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2">
                  <div className="bg-background-50 rounded-lg border border-background-200/70 py-2 px-1 min-w-[200px]">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="flex items-center gap-3 px-4 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 whitespace-nowrap transition-colors duration-150"
                      >
                        <span className="w-5 h-5 flex items-center justify-center">
                          <i className={`${cat.icon} text-base`}></i>
                        </span>
                        <span>{cat.name}</span>
                        <span className="ml-auto text-xs text-foreground-400">{cat.count}</span>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link to="/about" className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 ${textColor} ${isHome && !scrolled ? 'hover:text-white/80' : 'hover:text-primary-600'}`}>
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-300 ${isHome && !scrolled ? 'text-white border border-white/40 hover:bg-white/10' : 'text-foreground-700 border border-background-300 hover:border-primary-400 hover:text-primary-600'}`}>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line"></i>
              </span>
              搜索
            </button>
            <Link
              to="/category/fantasy"
              className="bg-primary-500 text-background-50 px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
            >
              开始阅读
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${isHome && !scrolled ? 'text-white' : 'text-foreground-800'}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/60 py-4 px-4 max-w-[1400px] mx-auto">
            <div className="flex flex-col gap-2">
              <Link to="/" className="py-3 px-4 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100">首页</Link>
              <div className="text-sm font-medium text-foreground-500 py-3 px-4">分类浏览</div>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-3 py-2.5 px-6 rounded-lg text-sm text-foreground-600 hover:bg-background-100"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={`${cat.icon} text-base`}></i>
                  </span>
                  <span>{cat.name}</span>
                  <span className="ml-auto text-xs text-foreground-400">{cat.count}</span>
                </Link>
              ))}
              <Link to="/about" className="py-3 px-4 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100">关于我们</Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}